export default __webpack_public_path__ + "media/images/snow_covered_-6ecf87742148758a731031a9a6e8be51.png";